import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { login, } from '../../store/modules/authSlice';
import { Button, Card, Modal, Theme, TextField } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import loginLogo from '../../assets/images/loginLogo.png'
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import { consts } from '../../common/consts'
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { ReactComponent as SMALogo } from '../../assets/svgs/smalogo.svg';
import { useHistory } from "react-router-dom";

import footerLogo from '../../assets/svgs/login/footer-logo.svg'
import { amountActiveSessionExceeded } from '../../common/phrases';
import { signIn } from './loginHelpers';
import AusMadeLogo from '../../assets/svgs/login/aus-made-logo.svg'
import AusOperatedLogo from '../../assets/images/AO-logo.png'




interface LoginWidgetProps extends React.Props<any> {
    finishLogin(isSuccess: boolean, token: string): void,
    goToForgotPassword(): void,
    goToLoginOTP(username: string, password: string, isSMS: boolean): void
};

interface Props {
    /**
     * Injected by the documentation to work in an iframe.
     * You won't need it on your project.
     */
    window?: () => Window;
    children: React.ReactElement;
}

function ElevationScroll(props: Props) {
    const { children, window } = props;
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window ? window() : undefined,
    });

    return React.cloneElement(children, {
        elevation: trigger ? 4 : 0,
    });
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {

    },

    inputs: {
        fontSize: 14,
    },

    button: {
        minWidth: 200,
        backgroundColor: '#FFB500',
        color: '#ffffff',
        borderRadius: 30,
        marginBottom: 40,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#FFFFFF',
        },
    },
    link: {
        color: '#F5F5F5',
        paddingLeft: 0,
        fontSize: 'small'
    },
    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 374.67,
    },
    logoRoot: {
        height: 212
    },
    alertErrorRoot: {
        marginBottom: 20,
    },
    textFieldRoot: {
        width: '100%',
        marginBottom: 20,
        '& .MuiOutlinedInput-root': {

            '&:hover fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'rgba(255,255,255, 0.25)',
            },
        },
        '& .MuiOutlinedInput-input': {
            padding: '10px 10px',
        },
        borderRadius: '5px',
    },

    textFieldInput: {
        backgroundColor: '#ffffff',
        color: '#666666',
        borderRadius: '0px',
    },

    logo: {
        width: 220,
        height: 180,
    },
    navbar: {
        height: 142,
        display: 'flex',
        alignContent: 'center',
        position: 'sticky',
        justifyContent: 'center',
    },
    background: {
        backgroundColor: '#001630',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-03-1.jpg)',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
    },
    header: {
        justifyContent: 'center',
        backgroundImage: 'url(https://smalive.wisdom.com.au/app/uploads/2021/06/bg-overlay-02.png)',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        opacity: '1',
        transition: 'background 0.3s, border-radius 0.3s, opacity 0.3s',
        display: 'flex',
        padding: '350px 0px 300px 0px',
    },
    widgetHeadings: {
        fontSize: 35,
        fontWeight: 800,

    },
    widgetBody: {
        fontSize: 16,
        fontWeight: 600,
    },
    contentContainer: {
        maxWidth: 1700,
        margin: 'auto',
        width: "-webkit-fill-available",
        paddingLeft: 50,
        paddingRight: 50,
    },
    headerBody: {
        display: 'flex',
    },
    widgetContent: {
        padding: 40,
        textAlign: 'center',
    },
    icon: {
        width: '70px',
        height: '70px',
    },
    menuBody: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    menu: {
        fontWeight: 700,
        fontSize: '16px',
        color: '#FFF',
        padding: '20px',
        '&:hover': {
            color: '#FFB500',
            textDecorationThickness: '3px',
            textUnderlineOffset: '10px'
        },
    },

    body: {
        display: 'flex',
        justifyContent: 'center'
    },
    widgets: {
        display: 'flex',
        alignContent: 'space-between',
        alignItems: 'space-between',
        justifyContent: 'space-between',
    },
    yAdjustment: {
        '--translateY': '-147.9px',
        transform: 'translateY(var(--translateY))',
    },
    widget: {
        backgroundColor: '#FFB500',
        borderRadius: '20px',
        width: '32%',
        maxWidth: '32%',
        textAlign: 'center',
    },
    headerLogin: {
        flexGrow: 1,
    },
    headerHeading: {
        flexGrow: 2,
        alignSelf: 'center',
    },
    heading: {
        fontSize: '100px',
        color: '#FFFFFF',
        fontWeight: 800,
        lineHeight: '1.2em',
        margin: 0,
        alignSelf: 'center',
    },
    loginHeaderButton: {
        backgroundColor: '#FFB500',
        borderRadius: 30,
        padding: '12px 30px',
        fontSize: 14,
        fontWeight: 800,
        '&:hover': {
            color: '#0049a3',
            backgroundColor: '#FFFFFF',
        },
    },
    loginText: {
        color: '#ffffff',

    },
    bodyHeading: {
        fontSize: 50,

    },
    aboutArea: {
        marginTop: 150,
    },
    h3: {
        fontSize: 30,
    },
    p: {
        fontSize: 20,
    },
    emailLink: {
        color: '#5292d1',
        textDecoration: 'none',
    },
    loginBodyButton: {
        backgroundColor: '#FFB500',
        borderRadius: 30,
        padding: '12px 30px',
        fontSize: 14,
        fontWeight: 800,
        '&:hover': {
            color: '#fff',
            backgroundColor: '#0049a3',
        },
    },
    bodyDivider: {
        borderRight: '2px solid #5292d1',
    },
    divider: {
        height: 120,
        backgroundColor: 'transparent',
        backgroundImage: 'linear-gradient(180deg, #0049A300 0%, #0049A352 100%)',
        opacity: '0.5',
        marginBottom: 100,
    },
    partners: {
        paddingTop: 40,
        paddingBottom: 40,
        display: 'flex',
        justifyContent: 'space-evenly'
    },
    andMore: {
        backgroundColor: '#ffb500'
    },
    footericons: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        textAlign: 'center',
        flexWrap: 'wrap',
    },
    iconCaption: {
        fontSize: 22,
        fontWeight: 600,
        color: '#0049A3',
    },
    iconContainer: {
        width: '25%',
        maxWidth: '25%',
    },
    footer: {
        backgroundColor: '#001630',
        minHeight: 300,
        display: 'flex',
        textAlign: 'center',
    },
    footerLogo: {
        width: '269px',
    },
    footerLink: {
        color: '#fff',
        padding: 20,
        cursor: 'pointer',
        fontWeight: 'bold',
        '&:hover': {
            color: '#FFB500',
        },
    }
}));

function NewlineText(props: any) {
    const text = props.text;
    return <div style={{ whiteSpace: 'pre-wrap' }}>{text}</div>;
}


function LoginWidget(props: LoginWidgetProps): JSX.Element {
    const { handleSubmit, errors, control, formState, trigger, watch } = useForm();
    const preventDefault = (event: { preventDefault: () => any; }) => event.preventDefault();
    const history = useHistory();
    const dispatch = useDispatch();
    const classes = useStyles();

    const [errorMessage, setErrorMessage] = useState("");

    const [showPassword, setShowPassword] = useState(false);



    const handleSignIn = async (data: any) =>{
        await signIn(
            data,
            dispatch,
            props.finishLogin,
            props.goToLoginOTP,
            setErrorMessage
        );
    }

    const handleClickShowPassword = () => {

        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const TermsPage = () => {

        history.push('/terms-and-conditions');
    }

    const PrivacyPage = () => {

        history.push('/privacy');
    }

    const LoginPage = () => {

        history.push('/login');
    }

    const emailValue = watch("email", "");
    React.useEffect(() => {
        if (/[0-9]+/.test(emailValue)) {
            trigger();
        }
    }, [emailValue])

    return (
        <React.Fragment>
            <div className={classes.root}>
                <ElevationScroll {...props}>
                    <AppBar color='transparent' style={{ boxShadow: 'none' }}>
                        <Toolbar className={classes.navbar}>
                            <div className={classes.contentContainer} style={{ width: '-moz-available' }}>
                                <div className={classes.menuBody}>
                                    <SMALogo className={classes.logo} onClick={LoginPage} style={{ cursor: 'pointer' }} />
                                    <div className={classes.menu}>
                                        <Button variant="contained" color="primary" className={classes.loginHeaderButton}>
                                            Login
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Toolbar>
                    </AppBar>
                </ElevationScroll>

                <section style={{ backgroundImage: 'linear-gradient(180deg, #0016308C 0%, #00163000 100%)', backgroundColor: "transparent", position: 'fixed', width: '100%', height: '142px' }}>
                </section>

                <section className={classes.background}>
                    <div className={classes.header}>
                        <div className={classes.contentContainer} style={{ width: '-moz-available' }}>
                            <Grid spacing={3} className={classes.headerBody} container>
                                <Grid item xs={8} className={classes.headerHeading}>
                                    <h1 className={classes.heading}>
                                        Terms of Use
                                    </h1>
                                </Grid>
                                <Grid item xs={4} className={classes.headerLogin}>
                                    <form onSubmit={handleSubmit(handleSignIn)} id="login-box" >
                                        <h2 className={classes.loginText}>Login</h2>
                                        <div className={classes.inputs}>
                                            <Controller
                                                defaultValue=''
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{ classes: { root: classes.textFieldInput } }} variant='outlined' placeholder='Email Address / Employee Id' error={errors.email} helperText={errors.email ? errors.email.message : ""} />}
                                                name='email'
                                                rules={{
                                                    required: "Email Address / Employee Id is required",
                                                    pattern: {
                                                        value: consts.EmailEmployeeIDRegex,
                                                        message: "Invalid email address / employee id"
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className={classes.inputs}>
                                            <Controller
                                                defaultValue=''
                                                control={control}
                                                as={<TextField classes={{ root: classes.textFieldRoot }} InputProps={{
                                                    classes: {
                                                        root: classes.textFieldInput
                                                    },
                                                    endAdornment: <InputAdornment position="end">
                                                        <IconButton style={{ color: '#fff' }}
                                                            aria-label="toggle password visibility"
                                                            onClick={handleClickShowPassword}
                                                            onMouseDown={handleMouseDownPassword}>
                                                            {showPassword ? <Visibility /> : <VisibilityOff />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                }} variant='outlined' placeholder='Password' type={showPassword ? 'text' : 'password'} error={errors.password} helperText={errors.password ? errors.password.message : ""} />}
                                                name='password'
                                                rules={{
                                                    validate: (value) => {
                                                        if (/[0-9]+/.test(emailValue))
                                                            return true;
                                                        else if (value === "")
                                                            return "Password is required";
                                                        return true;
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div>
                                            <Button onClick={() => props.goToForgotPassword()} className={classes.link}>
                                                Forgot your password?
                                            </Button>
                                        </div>
                                        <Alert variant="filled" icon={<ReportProblemOutlinedIcon />} severity="error" classes={{ root: classes.alertErrorRoot }} style={{ display: errorMessage ? 'flex' : 'none' }}>
                                            <NewlineText text={errorMessage} />
                                        </Alert>
                                        <div className={classes.inputs}>
                                            <Button type='submit'
                                                disabled={formState.isSubmitting}
                                                className={classes.button}
                                                variant="contained">Sign In</Button>
                                        </div>
                                    </form>
                                 </Grid>
                            </Grid>
                        </div>
                    </div>
                </section>
                <section>
                    <div className={classes.contentContainer}>
                        <h1 style={{ fontSize: 50, lineHeight: '1.5',}}>SMA Live - Terms of Use</h1>
                        <p style={{ fontSize: 20, lineHeight: '1.5' }}>Welcome to SMA Live. You've been invited by one of our customers, who holds an account for our ambulance transport services (Primary Account), to use SMA Live so that you can book our services and share patient information to make the transport of patients safer & more efficient.</p>
                        <p style={{ fontSize: 20, lineHeight: '1.5' }}>Set out below are the terms of use for SMA Live. These terms of use are entered into between us, State Medical Assistance Pty Limited (ABN 34 164 973 077) and our related entities (we, us, our and other similar expressions) and you. Before you use SMA Live, it is important that you read, understand, and agree to these terms of use.</p>
                        <ol>
                            <li style={{ fontSize: 16, lineHeight: '1.5'}}><b>Acceptance of these terms of use<br /></b><strong>1.1</strong><br />Your use of and access to SMA Live is subject to these terms of use. Before you make a booking or submit any patient information through SMA Live, it is important that youread, understand, and agree to these terms of use. If you do not accept these terms, you won't be able to use SMA Live.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><b>Right to use<br />2.1<br /></b>To use SMA Live, you must be invited by us or the holder of a Primary Account to download and create a user profile (Profile) on a Primary Account.<br /><strong>2.2</strong><br />When setting up your Profile,you will need to create a username and password which will enable you to access and use SMA Live.<br /><strong>2.3</strong><br />Upon creation of your Profile, you will be granted a limited, non-exclusive, non-transferable, revocable right toaccess and use SMA Live on these terms of use.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><b>Your use of SMA Live<br />3.1</b><br />You must only use SMA Live to book our ambulance transport services on behalf of a Primary Account, to share information about each patient using the ambulance transport services and in accordance with the training we have made available or provided to you.<br /><b>3.2</b><br />You must ensure that your access and use of SMA Live is not illegal or prohibited by laws that apply to you.<br /><b>3.3</b><br />If you upload any patient information or content through SMA Live (Content), you warrant to us that:<br /><b>(a)</b><br />you have obtained all consents, licences or permits necessary to include any images, names or likeness of persons and any identifiable third-party properties in the Content;<br /><b>(b)</b><br />the use of the Content as contemplated in these terms of use does not infringe the rights of any third party;<br /><b>(c)</b><br />the Content is not false, inaccurate or misleading, defamatory, unlawfully threatening or unlawfully harassing, obscene and does not contain pornography;<br /><b>(d)</b><br />the sharing of the Content will not violate any applicable law;<br /><b>(e)</b><br />the Content does not contain any trap door, Trojan horse, virus, worm, spy-ware, or other harmful code or disabling device or any virus designed to limit or destroy the functionality of other computer software or hardware.<br /><b>3.4</b><br />You must not, nor cause or permit a third party to:<br /><b>(a)</b><br />take, download or remove any information or Content from SMA Live whether or not you originally uploaded it;<br /><b>(b)</b><br />use SMA Live in a manner or for a purpose which is improper, immoral or fraudulent, which infringes any person's intellectual property rights, or which restricts or interferes with our provision of SMA Live to other users;<br /><b>(c)</b><br />reverse engineer, reverse assemble or reverse compile or copy or duplicate or modify or make derivative works of or re-sell all or part of SMA Live (or any of our intellectual property rights in SMA Live)<br /><b>(d)</b><br />gain or attempt to gain unauthorised access to SMA Live, computer systems or networks connected to SMA Live, including through hacking, password mining or any other means; or<br /><b>(e)</b><br />use data mining, robots, screen scraping or similar data gathering and extraction tools on SMA Live for establishing, maintaining, advancing or reproducing information contained in SMA Live, on your own website or in any other publication, or for your own personal use or benefit (other than as expressly set out in these terms of use), except with our prior written consent.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><strong>Data and privacy<br />4.1<br /></strong>We are committed to protecting data and privacy. We take all reasonable precautions to protect personal information that you upload to SMA Live but do not warrant the security of thatinformation.<br /><strong>4.2</strong><br />For further information on how we deal with personal information, please see our <span style={{ color: '#5292d1' }}><a style={{ color: '#5292d1' }} href="https://www.statemedicalassistance.com.au/sma-privacy-policy/" >Privacy Policy</a></span>.<br /><strong>4.3</strong><br />Several parties will have access to the Content that you upload on SMA Live, including us, the holder of the Primary Account connected to your Profile, and any health care professionals involved in providing the ambulance transport services.<br /><strong>4.4</strong><br />By uploading the Content, you grant to us a license to access, use, reproduce, modify, adapt, publish and display the Content through SMA Live. You also consent to our use of any other personal information given to us by you or others, for the purposes associated with the provision and use of SMA Live.<br /><strong>4.5</strong><br />We are not responsible for any subsequent use and disclosure of Content once posted through SMA Live. Each party involved in the care and treatment of patients who use our ambulance transport services are responsible for their own collection, use and disclosure of the Content.<br /><strong>4.6</strong><br />For further information on how a Primary Account holder will use and disclose Content and any other personal information uploaded to SMA Live, please contact that Primary Account holder directly.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><strong>Service Availability<br />5.1<br /></strong>While we intend to use reasonable endeavours to make SMA Live available for your use on a 24 hour a day, seven days a week basis, you agree that service continuity is not assured and that SMA Live is provided on an 'as is' basis. In particular, you agree that on occasions SMA Live may be unavailable or have limited availability including:<br /><b>(a)</b><br />to permit routine or emergency maintenance to take place;<br /><b>(b)</b><br />to permit upgrades or other development activity to take place;<br /><b>(c)</b><br />due to technical malfunctions of your software, equipment or infrastructure (e.g. telecommunications connectivity, network congestion or delays);<br /><b>(d)</b><br />due to a force majeure event; or<br /><b>(e)</b><br />due to clause 5.3 applying.<br /><b>5.2</b><br />In the case of technical problems which adversely affect your use of SMA Live, you must make all reasonable efforts to investigate and diagnose problems before contacting us. If you still need technical help, you must notify us promptly via email to <a href="mailto:support@statemedicalassistance.com.au"><span style={{ color: '#5292d1' }}>support@statemedicalassistance.com.au</span></a><span style={{ backgroundColor: 'transparent' }}>.<br /></span><b>5.3</b><br />We may temporarily limit or suspend the availability of all or part of SMA Live if it is necessary for reasons of public safety, security or maintenance of SMA Live, interoperability of services, data protection or to perform work that is necessary for operational or technical reasons.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><strong>Term<br />6.1<br /></strong>These terms of use apply to your use of and access to SMA Live from the date you first accept these terms of use and continue until either you or we terminate your account with SMA Live in accordance withthese terms of use.<br /><b>6.2</b><br />You may terminate your account with SMA Live by deleting SMA Live from your device and giving us at least 7 days' notice in writing (including by email) that you would like us to deactivate your account.<br /><strong>6.3</strong><br />We may terminate your account with SMA Live at any time, including if:<br /><strong>(a)</strong><br />we decide to no longer provide SMA Live;<br /><strong>(b)</strong><br />the Primary Account has been terminated; or<br /><strong>(c)</strong><br />you are in breach of these terms of use.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><strong>Suspension<br /></strong><strong>7.1<br /></strong>We may without notice suspend your access to SMA Live if:<br /><b>(a)</b><br />you breach these terms of use; or<br /><b>(b)</b><br />we reasonably believe that your access and use of SMA Live will cause technical incapacity to SMA Live which will continue unless access or use is suspended.<br /><b>7.2</b><br />If we do need to suspend your access to SMA Live, we'll act promptly to restore your access as soon as we're satisfied that the reason for suspension has been dealt with.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><strong>Limitation of liability<br />8.1<br /></strong>Nothing in these terms of use is or should be interpreted as an attempt to modify, limit or exclude any right or remedy, or any guarantee, term, condition, warranty, undertaking, inducement or representation, implied or imposed by legislation which cannot be modified, limited or excluded.<br /><strong>8.2</strong><br />We exclude to the extent permitted by law all other guarantees, terms, conditions, warranties, undertakings, inducements or representations whether express or implied, statutory or otherwise, which would otherwise be implied into these terms of use concerning the activities covered by these terms of use.<br /><strong>8.3</strong><br />You agree that you do not rely on any guarantee, term, condition, warranty, undertaking, inducement or representation made by us or on our behalf which is not expressly stated in these terms of use. In particular, we make no warranty or representation that:<br /><strong>(a)<br /></strong>SMA Live will always be available, accessible, secure or operate without error;<br /><strong>(b)</strong><br />SMA Live will be fit for your purposes; or<br /><strong>(c)</strong><br />SMA Live will be compatible with your equipment, devices and software configurations.<br /><strong>8.4</strong><br />Where any legislation implies or imposes a guarantee, term, condition, warranty, undertaking, inducement or representation in relation to these terms of use and we are not able to exclude that guarantee, term, condition, warranty, undertaking, inducement or representation (<strong>Non-Excludable Provision</strong>), and we are able to limit your remedy for a breach of the Non-Excludable Provision, then our liability for breach of the Non-Excludable Provision is limited to (at our election):<br /><strong>(a)</strong><br />in the case of goods, the repair or replacement of the goods or the supply of equivalent goods (or the payment of the cost of doing so); and<br /><strong>(b)</strong><br />in the case of services, the supplying of the services again (or the payment of the cost of doing so).<br /><strong>8.5</strong><br />Subject to our obligations under the Non-Excludable Provisions and clause 8.6, our maximum aggregate liability to you in respect of any one claim or series of connected claims under these terms of use or in connection with its subject matter, whether arising in or for breach of contract, negligence or other tort, breach of statutory duty, or under an indemnity or otherwise is limited to $1.<br /><strong>8.6</strong><br />We are not liable for any economic loss, loss of revenue, loss of saving on overheads, loss arising from business interruption, loss of goodwill or loss of profits, whether direct or indirect, general, special or consequential from any cause except as set out in this clause 8, even if we have been advised of the possibility of such damage or loss.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><strong>Indemnity<br />9.1<br /></strong>You agree to hold harmless and indemnify us and our officers, agents and employees against any loss, damage, costs or expenses that we, or any of our officers, agents and employees, may incur in connection with:<br /><strong>(a)</strong><br />your breach of these terms of use or any other legal obligation;<br /><strong>(b)</strong><br />your use of SMA Live or any use of SMA Live associated with your Profile;<br /><strong>(c)</strong><br />any cyber attack on SMA Live the result of any act or omission by you.<br /><strong>9.2</strong><br />The indemnity in this clause is a continuing obligation, separate and independent from the other obligations of the parties. This indemnity will not be affected by any matter including without limitation, the termination, renewal or extension of these terms of use or any indulgence, waiver or other concession given by us unless we agree in writing.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5' }}><strong>Variations<br />10.1<br /></strong>We may amend or update these terms of use from time to time.<br /><strong>10.2</strong><br />If any change to these terms of use will significantly affect the provision of SMA Live, we will give you at least 14 days' notice of the change.<br /><strong>10.3</strong><br />If you do not agree to any change to these terms of use, you can terminate your subscription to SMA Live in accordance with clause 6.2.<br /><strong>10.4</strong><br />You agree that your continued use of SMA Live will represent an agreement by you to be bound by the terms of use as amended.</li>
                            <li style={{ fontSize: 16, lineHeight: '1.5', marginBottom: 100, }}><strong>General<br />11.1<br /></strong>These terms of use constitute the entire understanding between the parties and supersede all previous and contemporaneous communications, representations, or agreements with respect to your access and use of SMA Live.<br /><strong>11.2</strong><br />No failure or delay of either party in exercising any right, power, or privilege under these terms of use (and no course of dealing between the parties) operates as a waiver of any such right, power of privilege. No waiver of any default on any one occasion constitutes a waiver of any subsequent default. No single or partial exercise of any right, power, or privilege precludes the further or full exercise of such right, power or privilege.<br /><strong>11.3</strong><br />If any provision of these terms of use is held to be unenforceable, the parties agree to substitute the affected provision with an enforceable provision that approximates the intent and economic effect of the affected provision.<br /><strong>11.4</strong><br />If any one or more of the provisions of these terms of use are for any reason held to be invalid, illegal or unenforceable by a court of competent jurisdiction or a panel of arbitrators, the remaining provisions of these terms of use will be unimpaired and will remain in full force and effect.<br /><strong>11.5</strong><br />Each party must do everything reasonably required by the other to give full effect to these terms of use.<br /><strong>11.6</strong><br />These terms of use and all matters regarding the interpretation and enforcement of these terms of use, are governed exclusively by the laws in force in the State of New South Wales, Australia and the parties submit to the non-exclusive jurisdiction of the courts of New South Wales.</li>
                        </ol>
                    </div>
                </section>

                <section className={classes.footer}>
                    <div className={classes.contentContainer} style={{ width: '100%' }}>

                        <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', justifyContent: 'space-between' }}>

                            <div style={{ maxWidth: '300px', display: 'flex', textAlign: 'left', alignItems: 'center' }}>
                                <img src={AusOperatedLogo} style={{ width: 100, marginRight: 20, }} />
                                <a style={{ color: '#fff' }}>State Medical Assistance (SMA) is proudly 100% Australian owned</a>
                            </div>

                            <div style={{ width: "1px", height: "auto", backgroundColor: 'rgba(255, 255, 255, 0.15)' }}>
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', maxWidth: 300, textAlign: 'center', alignItems: 'center', }}>
                                <img src={footerLogo} className={classes.footerLogo} />
                                <a style={{ color: '#fff', marginTop: 10 }}>SMA Live is a product of State Medical Assistance</a>
                            </div>

                            <div style={{ width: "1px", height: "auto", backgroundColor: 'rgba(255, 255, 255, 0.15)' }}>
                            </div>

                            <div style={{ maxWidth: '300px', display: 'flex', textAlign: 'left', alignItems: 'center' }}>
                                <a style={{ color: '#fff' }}>SMA Live is proudly designed, developed and hosted in Australia</a>
                                <img src={AusMadeLogo} style={{ width: 100 }} />
                            </div>
                        </div>


                        <div style={{ marginTop: 40, paddingTop: 40, borderTop: "1px solid rgba(255, 255, 255, 0.15)" }}>
                            <a onClick={TermsPage} className={classes.footerLink} >Terms of Use</a>
                            <a onClick={PrivacyPage} className={classes.footerLink}>Privacy Policy</a>
                        </div>
                    </div>
                </section>
            </div>

        </React.Fragment >
    );
}

export default React.memo(LoginWidget)